import { TextField } from '@mui/material';

import { TextInputFormProps } from './types';
import { useEffect, useRef } from 'react';

const TextInputForm = (props: TextInputFormProps) => {
  const {
    value,
    setValue,
    isValid,
    setIsValid,
    validate,
    errorMessage,
    autoFocus,
    ...options
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  // auto focus setting
  useEffect(() => {
    if (autoFocus !== undefined && autoFocus !== false && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [autoFocus]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newValue = e.target.value;
    setValue(newValue);

    // if value empty, valid
    if (!newValue) {
      setIsValid(true);
    }

    setIsValid(validate(newValue));
  };

  return (
    <TextField
      error={!isValid}
      helperText={!isValid ? errorMessage : ''}
      variant='outlined'
      fullWidth
      value={value}
      onChange={handleChange}
      inputRef={inputRef}
      {...options}
    />
  );
};

export default TextInputForm;
